import { createContext, useContext } from 'react';

export enum PurchaseOrderStep {
  SELECT_PRODUCTS = 1,
  DELIVERY = 2,
  CONFIRM = 3
}

export const PurchaseOrderNavigationContext = createContext<
  ((link: string, step?: PurchaseOrderStep) => void) | undefined
>(undefined);

export const usePONavigateAndValidate = () => {
  const navigateAndValidate = useContext(PurchaseOrderNavigationContext);

  if (!navigateAndValidate) {
    throw Error('usePONavigateAndValidate must be used within a PurchaseOrderNavigationProvider');
  }

  return navigateAndValidate;
};
